import React from "react";

export const EllipsishIcon = ({...props}) => {
  return (
    <>
      <path d="M21,14.25 C22.2421875,14.25 23.25,13.2421875 23.25,12 C23.25,10.7578125 22.2421875,9.75 21,9.75 C19.7578125,9.75 18.75,10.7578125 18.75,12 C18.75,13.2421875 19.7578125,14.25 21,14.25 Z M3,14.25 C4.2421875,14.25 5.25,13.2421875 5.25,12 C5.25,10.7578125 4.2421875,9.75 3,9.75 C1.7578125,9.75 0.75,10.7578125 0.75,12 C0.75,13.2421875 1.7578125,14.25 3,14.25 Z M12,14.25 C13.2421875,14.25 14.25,13.2421875 14.25,12 C14.25,10.7578125 13.2421875,9.75 12,9.75 C10.7578125,9.75 9.75,10.7578125 9.75,12 C9.75,13.2421875 10.7578125,14.25 12,14.25 Z" />
    </>
  );
};